import renderAdvanceNurseryConfigurationModal from "../../../infrastructure/renders/AdvanceNurseryBenefitModal/render-advance-nursery-configuration-modal";
import { configureNursery } from "../../../infrastructure/repository/nursery-repository";
import { translate } from "../../../infrastructure/translate/localization";
import { hideModal } from "../../commons/hide-modal";
import { showSuccessMessage } from "../../commons/show-success-message";
import { displayBenefitPage } from "../displays/display-benefit-page";

export default function configureNurseryBenefit({ benefit, country }) {
  renderAdvanceNurseryConfigurationModal({
    benefit,
    country,
    callback: async (payload) => {
      await configureNursery(payload);
      hideModal();
      showSuccessMessage(translate("common-messages.basic-success-message"));
      displayBenefitPage(benefit.id);
    },
  });
}
